import { render } from "./vmenuadd.vue?vue&type=template&id=1e9c2e50&scoped=true"
import script from "./vmenuadd.vue?vue&type=script&lang=js"
export * from "./vmenuadd.vue?vue&type=script&lang=js"

import "./vmenuadd.vue?vue&type=style&index=0&id=1e9c2e50&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9c2e50"]])

export default __exports__